import api from './api';
import { FeedbackRequest } from '../types';

// Send feedback from the logged-in user
export const submitFeedback = async (feedback: FeedbackRequest): Promise<void> => {
    await api.post('/api/feedback', feedback);
};